import { PrivateInterceptor } from "../../../../Base/interceptors/PrivateInterceptor";
import { PrivateInterceptorsPR } from "../../../../Base/interceptors/PrivateinterceptorsPR";

// GET PERSONAL
export const getListPersonal = async (User) => {
const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
    funcion: 0,  
    USUARIO: User
})
return result;
}
// GET LISTADO PERMISOS
export const getListadoPermisos = async (Fecha1, Fecha2) => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 26,
        Fecha1: Fecha1,
        Fecha2: Fecha2
    })
    return result;
}

// GET LISTADO AUTORIZA
export const getListadoAutoriza = async (User) => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 6,
        USUARIO: User
    })
    return result;
}
// GET LISTADO TIPO PERMISOS
export const getListadoTipoPermiso = async (Date, User) => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 7
    })
    return result;
}

// CREAR UN PERMISO 
export const crearPermisoRRHH = async (values) => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 2,
        GuardarEditar: [values]
    })
    return result;
}

// GET LISTADO ESTADOS
export const getListadoEstadosPermiso = async () => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 8
    })
    return result;
}

// CANCELAR PERMISOS
export const cancelarPermisos = async (items) => {
    console.log('alsdkjfl');
    const a = items.map(e => e.Id)
    console.log(a.toString());
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 27,
        IdCheck: a.toString()
    })
    return result;

}

export const getListadoPermisosPersonal = async (User) => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 22, //10 -> GA, 16 -RH
        USUARIO: User
    })
    return result;
}
export const getListadoPermisosAprobarRRHH = async () => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 16, //10 -> GA, 16 -RH
    })
    return result;
}
export const getListadoPermisosAprobarGerencia = async (User) => {
    const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
        funcion: 10, //10 -> GA, 16 -RH
        USUARIO: User
    })
    return result;
}

export const autorizarPermisoRH = async (items, isRRHH, Password, idPersonal) => {
    const n = await verificarCredencialsAutorizarPermisos(isRRHH ? 'PermisoPersonal' : 'IPS', Password, idPersonal);
    console.log(n);
    console.log(items)
    if (n.length > 0) {
        if (n[0]?.count > 0) {
            const a = items.map(e => e.Id)
            const result = await PrivateInterceptorsPR('RRHH/Permisos', 'POST', {
                funcion: isRRHH ? 14 : 12, //12 -> GA, 14 -> RH
                IdCheck: a.toString()
            })
            console.log(result);
            return true;
        }
    }
    return false;
}

export const verificarCredencialsAutorizarPermisos = async (Window, Password, idPersonal) => {
    const result = await PrivateInterceptor('Accesos/AccesoPermisoPersonal', 'POST', { Window, Password, idPersonal });
    return result

}